import { UPDATE_REPORT_DATA, RESET_REPORT_DATA } from "../actions";

const INITIAL_STATE = {
  isLoading: false,
  payments: [],
  feeAccounts: [],
  accountants: [],
  campuses: [],
  daywiseReportData: [],
  students:[],
  campuses:[],
  classrooms:[],
  salesReport: [],
  receiptsReport:[]
};

const reportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_REPORT_DATA:
      return { ...state, ...action.payload };
    case RESET_REPORT_DATA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reportReducer;
